import { Requirement } from ".";
import { SectionVersion } from "../components/sections/SectionVersion";

export class RequirementItem<T> {
	public static readonly $type = {
		DataFieldTemplate: "RequirementItem<DataFieldTemplate>",
		ComponentTemplate: "RequirementItem<ComponentTemplate>"
	};
	public readonly $type: string = RequirementItem.$type.DataFieldTemplate;

	public id?: number;
	public owningRequirement!: Requirement<T>;
	public initialOrder!: number;
	public item!: T;
	public getParent?(): SectionVersion;

	constructor(genericTypeName: "DataFieldTemplate" | "ComponentTemplate") {

		this.$type = `${"RequirementItem"}<${genericTypeName}>`;
	}
}
